export default __webpack_public_path__ + "static/media/better_gazirana_05.639d0ac9.jpg";